<template>
  <v-navigation-drawer
    v-model="drawer"
    app
    dark
    class="drawer"
    expand-on-hover
    fixed
    :mini-variant.sync="mini"
    permanent
  >
    <v-list>
      <v-list-item
        v-for="(link, index) of quicklinks"
        :key="'quicklink-' + index"
        :title="link.title"
        :to="{name: link.route}"
      >
        <v-list-item-icon>
          <v-icon>{{ link.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ link.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-divider />

    <v-list subheader>
      <v-subheader
        :class="{'d-none' : mini}"
      >
        Tools
      </v-subheader>
      <v-list-item
        v-for="(link, index) of tools"
        :key="'toolslink-' + index"
        :title="link.title"
        :to="{ name: link.route }"
      >
        <v-list-item-action>
          <v-icon>{{ link.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{ link.title }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <template #append>
      <v-list-item class="create-record mb-2">
        <v-list-item-action
          v-if="canCreateRecord"
          large
          color="primary"
          title="Create Record"
          @click="checkIfRecordDialogOpen"
        >
          <v-icon>add</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title
            v-if="canCreateRecord"
            @click="checkIfRecordDialogOpen"
          >
            New Record
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

import { INTEGRATION_NAMESPACE } from '@/store/integrations'

export default {
  name: 'NavDrawer',

  props: {
    drawerOpen: {
      type: Boolean,
      required: true,
    },
  },

  data () {
    return {
      canCreateRecord: false,
      drawer: true,
      mini: true,
      quicklinks: [
        { icon: 'home', route: 'dashboard', title: 'Dashboard' },
        { icon: 'folder_open', route: 'data-records', title: 'Records' },
        // TODO: { icon: 'mdi-calendar-alert', route: 'appointment-requests', title: 'Appointment Requests' },
      ],

      tools: [],
    }
  },

  computed: {
    currentUser () {
      return this.$store.state.currentUser
    },

    drawerState: {
      get () {
        return this.drawerOpen
      },

      set (newValue) {
        if (newValue !== this.drawerOpen) this.$emit('update-drawer', newValue)
      },
    },

    ...mapGetters(INTEGRATION_NAMESPACE, [
      'ecoPortalEnabled',
    ]),
  },

  created () {
    if (this.currentUser.canCreateRecord) this.canCreateRecord = true

    if (!this.currentUser.isExternal) {
      this.mergePartyLink()
      this.calendarLinks()
      this.advancedSearchLink()
    }
    if (this.currentUser.isAdmin) {
      this.loadAdminLinks()
      this.checkEcoPortalEnabled().
        finally(_ => this.loadEcoPortal())
    }
  },

  methods: {
    advancedSearchLink () {
      const link = {
        icon: 'search',
        route: 'advanced-search',
        title: 'Advanced Search',
      }

      this.quicklinks.push(link)
    },

    calendarLinks () {
      const links = [
        {
          icon: 'mdi-calendar-account',
          route: 'calendar',
          title: 'Calendar',
        },
        {
          icon: 'mdi-calendar-heart',
          route: 'day-at-a-glance',
          title: 'Day at a Glance',
        },
      ]

      this.quicklinks = this.quicklinks.concat(links)
    },

    checkIfRecordDialogOpen () {
      if (!this.$store.state.dialogOpenStates.createRecord) this.setCreateRecordDialog(true)
    },

    loadAdminLinks () {
      const links = [
        {
          icon: 'group_add',
          route: 'import-party',
          title: 'Import Party',
        },
        {
          icon: 'mdi-finance',
          route: 'management-reports',
          title: 'Reports',
        },
        {
          icon: 'quiz',
          route: 'party-surveys',
          title: 'Party Surveys',
        },
      ]
      for (const link of links) this.tools.push(link)
    },

    loadEcoPortal () {
      if (this.ecoPortalEnabled) {
        const link = {
          icon: 'table_rows ',
          route: 'integrationEcoPortal',
          title: 'ECO Portal Exports',
        }
        this.tools.push(link)
      }
    },

    mergePartyLink () {
      const link = {
        icon: 'people_alt',
        route: 'merge-party',
        title: 'Merge Party',
      }

      this.quicklinks.push(link)
    },

    ...mapMutations([
      'setCreateRecordDialog',
    ]),

    ...mapActions(INTEGRATION_NAMESPACE, [
      'checkEcoPortalEnabled',
    ]),

  },
}
</script>
